﻿
// --------------------------------------------------------------
// Components
// --------------------------------------------------------------

// --------------------------------------------------------------
// Styles
// --------------------------------------------------------------

export default class InfoBox {
    constructor() {

    }
}
